








import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { AppUtil } from '../../utils/app.util';
import userService from '@/service/userService';

@Component
export default class SetCode extends Vue {
  private isWaitCode: boolean = false; // 是否等待
  private times: number = 60; // 倒计时
  private tips: string = '获取验证码'; // 提示语
  private propMobile: string = ''; // 手机号
  @Prop() private mobile!: string
  private check: boolean = true; // 是否校验手机号
  @Emit('sendAfter') private sendAfter(res: boolean) {
    return res
  }

  validPhone() {
    if (AppUtil.isEmpty(this.mobile) || (this.check && !AppUtil.isPhoneNumber(this.mobile))) {
      this.$Message.warning("请输入正确手机号!");
      return false;
    }
    return true;
  }

  sendCode() {
    if (this.validPhone()) {
      if (this.times == 60) {
        userService.sendCode(0, this.check ? this.mobile : '').then((res: any) => {
          if (res && res.success) {
            this.$Message.success("验证码已发送!");
            this.isWaitCode = true;
            this.sendAfter(true);
            let intObj = setInterval(() => {
              this.times--;
              if (this.times <= 0) {//清除定时器
                clearInterval(intObj);
                this.isWaitCode = false;
                this.times = 60;
                this.tips = "重新获取验证码";
              }
            }, 1000);
          } else {
            this.$Message.error("验证码发送失败!");
            this.isWaitCode = false;
            this.sendAfter(false);
          }
        }, () => {
          this.$Message.error("验证码发送失败!");
          this.isWaitCode = false;
          this.sendAfter(false);
        });
      }
    }
  }
}
